
  <div class="main-wrapper">
        
        <section>
          <img src="https://www.unipay.cl/api/descargaArchivo/Landing Asistencia Salud v7_HTML-01.png" alt="Unipay">
        </section>

        <section>
        <a href="https://www.inzurit.cl/producto/detalle/eyJpdiI6InpUb3JlZGdWT2lDNzkrNVdUTlo4Snc9PSIsInZhbHVlIjoiSDJ5VWxhUXdQelEzYnAyQVBGd3crUT09IiwibWFjIjoiNmY4NmE3YTliZmFmZTc3NDMxMTIyY2JjNDU0ZTM1NzkyZTBjNzI1YWJkOTdkM2YwNmE4NTJiNWIxMzBiZDZiZiIsInRhZyI6IiJ9/eyJpdiI6Ii9CUkdVTWtGckpqNmdXOUwzRmZ0N1E9PSIsInZhbHVlIjoialdpcUN6SERKNlF0UUhnaWdyWUFJQT09IiwibWFjIjoiMmU4MzYwOTRhMDg0MjRkZjNiZjI5NmI4Mzc5YzVkYjYyMzFmMzM5NjliM2JjZjJlODI0MGJjMWNlMDI5OWIwZSIsInRhZyI6IiJ9" target="_blank" rel="noopener noreferrer"><img src="https://www.unipay.cl/api/descargaArchivo/Landing Asistencia Salud v7_HTML-02.png" alt="Ahorrado con Unipay"></a> </section>
	
<section>
      <a href="https://www.unipay.cl/autoatencion-ptoventa/validar-identidad?utm_source=Digital&amp;utm_medium=Unipay&amp;utm_campaign=botonlandingasistencia&amp;utm_content=Unipay" target="_blank" rel="noopener noreferrer"><img src="https://www.unipay.cl/api/descargaArchivo/Landing Asistencia Salud v7_HTML-03.png" alt=""></a> <img src="https://www.unipay.cl/api/descargaArchivo/Landing Asistencia Salud v7_HTML-04.png" alt="">
	  <img src="https://www.unipay.cl/api/descargaArchivo/Landing Asistencia Salud v7_HTML-05.png" alt="">
    </section>

        <section>
        <a  href="https://www.inzurit.cl/producto/detalle/eyJpdiI6InpUb3JlZGdWT2lDNzkrNVdUTlo4Snc9PSIsInZhbHVlIjoiSDJ5VWxhUXdQelEzYnAyQVBGd3crUT09IiwibWFjIjoiNmY4NmE3YTliZmFmZTc3NDMxMTIyY2JjNDU0ZTM1NzkyZTBjNzI1YWJkOTdkM2YwNmE4NTJiNWIxMzBiZDZiZiIsInRhZyI6IiJ9/eyJpdiI6Ii9CUkdVTWtGckpqNmdXOUwzRmZ0N1E9PSIsInZhbHVlIjoialdpcUN6SERKNlF0UUhnaWdyWUFJQT09IiwibWFjIjoiMmU4MzYwOTRhMDg0MjRkZjNiZjI5NmI4Mzc5YzVkYjYyMzFmMzM5NjliM2JjZjJlODI0MGJjMWNlMDI5OWIwZSIsInRhZyI6IiJ9" target="_blank" rel="noopener noreferrer"><img src="https://www.unipay.cl/api/descargaArchivo/Landing Asistencia Salud v7_HTML-06.png" alt="Marcas"></a> </section>
<section>

    </section>
        <section >
            <a href="https://www.unipay.cl/autoatencion-ptoventa/validar-identidad?utm_source=Digital&utm_medium=Unipay&utm_campaign=Pasos_Marzo2026" target="_blank" rel="noopener noreferrer">
            <img src="https://www.unipay.cl/api/descargaArchivo/Landing Asistencia Salud v7_HTML-07.png" alt="Obtén tu Unipay aquí">
            </a>
        </section>

        <section>
            <img src="https://www.unipay.cl/api/descargaArchivo/Landing-Asistencia-Salud_Preguntas.png" alt="">
        </section>
 <div class="faq-section">
            <div class="faq-container">
                <details>
                  <summary>
                    <strong>¿A quiénes cubre la Asistencia de Salud?</strong>
                 </summary>
                    <div class="faq-content">
                        <p>Cubre al titular y hasta 3 beneficiarios adicionales, sin límite de edad. Sin restricciones.</p>
                    </div>
                </details>

                <details>
                    <summary><strong>¿Cuándo puedo comenzar a usar la asistencia?</strong></summary>
                    <div class="faq-content">
                        <p>La asistencia se activa en un máximo de 72 horas después de la contratación.</p>
                    </div>
                </details>

                <details>
                    <summary><strong>¿Qué tipo de atenciones incluye?</strong></summary>
                    <div class="faq-content">
                        <p>Incluye consultas médicas presenciales, telemedicina, exámenes médicos, entre otros.</p>
                    </div>
                </details>

                <details>
                    <summary><strong>¿La asistencia tiene cobertura en todo Chile?</strong></summary>
                    <div class="faq-content">
                        <p>Sí. La asistencia cuenta con cobertura a nivel nacional en todos los centros médicos con red iMed, incluyendo la Isla Grande de Chiloé. Se excluyen los otros territorios insulares.</p>
                    </div>
                </details>

                <details>
                    <summary><strong>¿La asistencia cubre atención de urgencia?</strong></summary>
                    <div class="faq-content">
                        <p>No. La asistencia es una prestación para atenciones ambulatorias.</p>
                    </div>
                </details>

                <details>
                    <summary><strong>¿Qué debo hacer para agregar beneficiarios?</strong></summary>
                    <div class="faq-content">
                        <p>Una vez contratada tu asistencia, recibirás un correo electrónico con los pasos para agregar hasta 3 beneficiarios.</p>
                        <p>Debes considerar que, una vez registrados, los beneficiarios no podrán ser modificados ni reemplazados.</p>
                    </div>
                </details>

                <details>
                    <summary><strong>¿Cómo usar la telemedicina?</strong></summary>
                    <div class="faq-content">
                        <p>Una vez contratada la Asistencia de Salud tienes acceso al servicio de telemedicina, para eso debes ingresar y registrarte en <a href="https://www.telemedicina-unimarc.cl/" target="_blank" rel="noopener noreferrer">https://www.telemedicina-unimarc.cl/</a> </p>
                        <p>Desde la plataforma podrás agendar tu atención médica online y acceder a recetas, órdenes médicas y certificados.</p>
                    </div>
                </details>

                <details>
                    <summary><strong>¿Qué beneficiario puede ingresar?</strong></summary>
                    <div class="faq-content">
                        <p>La Asistencia de Salud Integral está disponible para el titular y sus beneficiarios, con un máximo de 4 integrantes en total (titular + 3 beneficiarios).</p>
                        <p>Si el titular no tiene cargas familiares directas, puede ceder los beneficios a terceros, respetando el máximo de eventos anuales contratados. No existe límite de edad para el ingreso ni permanencia.</p>
                    </div>
                </details>

                <details>
                    <summary><strong>¿Cuándo debo usar iMed? ¿Cuándo agendar cita médica a través del Call Center?</strong></summary>
                    <div class="faq-content">
                      <p>Depende del sistema previsional del beneficiario:</p>
                      <p>Si tienes FONASA o ISAPRE vigente debes asistir directamente a tu atención en centros médicos o clínicas que cuenten con sistema iMed (huella electrónica). allí se aplicará la bonificación del 100% del copago en línea. Si no cuenta con iMed o el servicio no esté disponible, debes llamar al 600 390 9000 para que te asignen un centro médico de la red convenio, pactado a conveniencia</p>
                      <p>&nbsp;Si tienes otro sistema previsional (Fuerzas Armadas, Capredena u otra), solo en estos casos, debes llamar al 600 390 9000</p>
<p><strong>&nbsp;</strong></p>
                  </div>
                </details>

                <details>
                    <summary><strong>¿Cómo pago mi Asistencia de Salud?</strong></summary>
                    <div class="faq-content">
                        <p>La asistencia tiene un valor mensual de $6.990 con Tarjeta Unipay y $7.990 con otros medios de pago. Con renovación automática.</p>
                    </div>
                </details>

                <details>
                    <summary><strong>¿Cómo se da de baja mi Asistencia de Salud?</strong></summary>
                    <div class="faq-content">
                        <p>El titular puede solicitar la baja de la asistencia a través del número de 600 390 9000 o a través del enlace que llega al correo de contratación de tu asistencia de salud.</p>
                    </div>
                </details>
				<details>
                    <summary><strong>¿Cómo puedo verificar que mi asistencia está activa?</strong></summary>
                    <div class="faq-content">
                        <p>Si tienes dudas sobre la activación de su asistencia puedes llamar al 600 390 9000.</p>
                    </div>
                </details>
				<details>
                    <summary><strong>¿La asistencia de salud tiene exclusiones?</strong></summary>
                    <div class="faq-content">
                        <p>Si, quedan excluidos las siguientes situaciones: autolesiones o participación en actos delictivos, práctica de deporte en competiciones oficiales, y enfermedades y/o accidentes causados por uso de estupefacientes, alcohol y/o droga.</p>
                    </div>
                </details>
    </div>
        </div>

        <section> </section>

    </div>